import ResumenRepository from '@/services/ResumenRepository'
import EstadisticasRepository from '@/services/EstadisticasRepository'
import ActividadesRepository from '@/services/ActividadesRepository'

export default {
  namespaced: true,
  state: {
    resumenCosto: [],
    resumenRendimientoFicha: [],
    resumenRendimientoVariedad: [],
    resumenEstadisticas: [],
    resumenMovimientos: [],
    resumenAnalisisProduccionAnimal: [],
    resumenCostosProduccionAnimal: {}
  },
  mutations: {
    setResumenCosto(state, resumenCosto) {
      state.resumenCosto = resumenCosto.map(item => {
        item.nombreCultivoVariedad = `${item.nombreCultivo} ${item.nombreVariedad}`
        return item
      })
    },

    setResumenRendimientoFicha(state, resumenRendimientoFicha) {
      state.resumenRendimientoFicha = resumenRendimientoFicha
    },

    setResumenRendimientoVariedad(state, resumenRendimientoVariedad) {
      state.resumenRendimientoVariedad = resumenRendimientoVariedad
    },

    setResumenEstadisticas(state, resumenEstadisticas) {
      state.resumenEstadisticas = resumenEstadisticas
    },

    setResumenMovimientos(state, resumenMovimientos){
      state.resumenMovimientos = resumenMovimientos
    },

    setResumenAnalisisProduccionAnimal(state, resumenAnalisis){
      state.resumenAnalisisProduccionAnimal = resumenAnalisis
    },

    setResumenCostosProduccionAnimal(state, resumenCostos){
      state.resumenCostosProduccionAnimal = resumenCostos
    },

    clearResumenMovimientos(state){
      state.resumenMovimientos = []
    },

    clearResumenAnalisis(state){
      state.resumenAnalisisProduccionAnimal = []
    }
  },
  actions: {
    async fetchResumenCosto({commit, rootState}) {
      let pIdEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let pIdGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion
      let idTemporada = rootState.temporada.temporada.idTemporada

      if(pIdEstablecimiento !== 0 && pIdGrupoExplotacion !== 0){
        let resumenCosto = await ResumenRepository.resumenCostoAgricultor(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada)
        commit('setResumenCosto', resumenCosto)
      }
    },

    async fetchResumenRendimientoFicha({commit, rootState}) {
      let pIdEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let pIdGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion
      let idTemporada = rootState.temporada.temporada.idTemporada
      
      if(pIdEstablecimiento !== 0 && pIdGrupoExplotacion !== 0){
        let resumenRendimientoFicha = await ResumenRepository.resumenRendimientoFichaAgricola(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada)
        commit('setResumenRendimientoFicha', resumenRendimientoFicha)
      }
    },

    async fetchResumenRendimientoVariedad({commit, rootState}) {
      let pIdEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let pIdGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion
      let idTemporada = rootState.temporada.temporada.idTemporada
      
      if(pIdEstablecimiento !== 0 && pIdGrupoExplotacion !== 0){
        let resumenRendimientoVariedad = await ResumenRepository.resumenRendimientoVariedad(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada) || []
        commit('setResumenRendimientoVariedad', resumenRendimientoVariedad)
      }
    },

    async fetchResumenEstadisticas({commit, rootState}) {
      let pIdEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let pIdGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion
      let idTemporada = rootState.temporada.temporada.idTemporada
      
      if(pIdEstablecimiento !== 0 && pIdGrupoExplotacion !== 0){
        let resumenEstadisticas = await EstadisticasRepository.estadisticasTipoTrabajoAgricultor(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada) || []
        commit('setResumenEstadisticas', resumenEstadisticas)
      }
    },

    async fetchResumenMovimientoFinanciero({commit, rootState}){
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera

      if(idFichaGanadera && idFichaGanadera !== 0){
        let resp = await ActividadesRepository.resumenMovimientoFinanciero(idFichaGanadera)
        commit('setResumenMovimientos', resp.resumenConcepto)
      }
    },

    async fetchResumenAnalisisProduccionAnimal({commit, rootState}){
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera

      if(idFichaGanadera && idFichaGanadera !== 0){
        let resp = await ResumenRepository.resumenAnalisisProduccionAnimal(idFichaGanadera)
        commit('setResumenAnalisisProduccionAnimal', resp)
      }
    },

    async fetchResumenCostosProduccionAnimal({commit, rootState}){
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera

      if(idFichaGanadera && idFichaGanadera !== 0){
        let resp = await ResumenRepository.resumenCostosProduccionAnimal(idFichaGanadera)
        commit('setResumenCostosProduccionAnimal', resp)
      }
    },

    clearResumenAnalisis({commit}){

      commit('clearResumenAnalisis')
      
    }
  }
}
